import initialState from './initialState';

export function dealFunder(state = initialState.dealFunder, action) {
  switch (action.type) {
    case 'DEAL_FUNDER_DETAILS_FETCH_DATA_RESULT':
      return {
        ...state,
        details: action.funderDetails,
        isLoading: false,
      };

    case 'DEAL_FUNDER_CLEAR_DETAILS':
      return {
        ...state,
        details: {},
      };

    case 'DEAL_FUNDER_DETAILS_LOADING':
      return {
        ...state,
        isLoading: action.isLoading,
        isSaving: false,
      };

    case 'DEAL_FUNDER_DETAILS_SAVING':
      return {
        ...state,
        isLoading: false,
        isSaving: action.isSaving,
      };

    case 'REDIRECT_TO_DEAL_FUNDER':
      return {
        ...state,
        redirectId: action.id,
      };

    default:
      return state;
  }
}
